import {
  Command,
  Mark,
  markInputRule,
  markPasteRule,
  mergeAttributes,
} from "@tiptap/core";

export const Subscript = Mark.create({
  name: "subscript",

  defaultOptions: {
    HTMLAttributes: {},
  },

  parseHTML() {
    return [
      {
        tag: "subscript",
      },
      {
        tag: "del",
      },
      {
        tag: "subscript",
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style) => (style.includes("line-through") ? {} : false),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "sub",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSub:
        () =>
        ({ commands }) => {
          return commands.setMark("subscript");
        },
      toggleSub:
        () =>
        ({ commands }) => {
          return commands.toggleMark("subscript");
        },
      unsetSub:
        () =>
        ({ commands }) => {
          return commands.unsetMark("subscript");
        },
    };
  },
});
